import { currentUser, selectedItem } from '../store/store.js';

export function calculateNettoskuld(totalAmountOfLoans, cashAtTheEndOfTheYear, skattekonto, klientmedel, kassaOchBank) {
	const loans = parseInt(totalAmountOfLoans) || 0;
	let cash = parseInt(cashAtTheEndOfTheYear) || 0;
	const skattekontoValue = parseInt(skattekonto) || 0;
	const klientmedelValue = parseInt(klientmedel) || 0;

	if (cash == 0) {
		cash = parseInt(kassaOchBank) || 0;
	}

	return loans - cash - skattekontoValue - klientmedelValue;
}

export function displayInt(number) {
	number = String(number);
	let match = number.match(/^-?\d+/);
	if (match) {
		number = match[0]; // Get the first match from the result array
	} else {
		return "-"; // Return a dash if no digits are found
	}
	
	if (number == 0) { // Check if number is valid and return it
		return "0";
	}
	if (number == null || number === undefined || number === "" || Number.isNaN(number)) {
		return "-";
	}

	return Number(number).toLocaleString('sv-SE');
}

export function displayBoolean(bool) {
    if (bool == true){
        return "Ja";
    }
    if (bool == false) {
        return "Nej";
    }
    if (bool == null || bool == undefined || bool == '') {
        return "Uppgifter saknas";
    }
}

export function getFileNameId(fileName){
    const parts = fileName.split('/');
    return parts[parts.length - 1];
}

export	function getFileName(fileName){
    return "https://storage.googleapis.com/brf-redovisningar-to-analyze/" + fileName;
}

export function getLivingArea(livingAreaSqm, annualFeeIncome, livingFeePerSqm) {
    if (livingAreaSqm !== null && livingAreaSqm !== undefined) {
        return livingAreaSqm;
    }
    if (annualFeeIncome !== null && annualFeeIncome !== undefined && livingFeePerSqm !== null && livingFeePerSqm !== undefined) {
        return Math.ceil(annualFeeIncome / livingFeePerSqm);
    }
    return null;
}

export async function fetchBrf(core_id = "", year = null) {
    try {
        let url = 'https://boanalys-backend-324523837899.europe-north1.run.app/get_core?core_id=' + core_id;
        if (year !== null && year !== undefined && year !== '') {
            url += '&year=' + year;
        }
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${currentUser?.accessToken}`
            }
        });
        if (!response.ok) {
            throw new Error('Misslyckades att hämta information om bostadsrättsföreningen.');
        }
        let data = await response.json();
        let core_history = data.core_history;
        if (data.data !== null){
            data = populateDataWithS(data.data);
        }
        if (data.living_area_sqm == null && data.annual_fee_income != null && data.living_fee_per_sqm != null && data.living_fee_per_sqm > 0){
            data.living_area_sqm = Math.round(data.annual_fee_income / data.living_fee_per_sqm);
        }

        if (data.total_amount_of_loans == null || data.total_amount_of_loans == undefined) {
            if (Array.isArray(data.loans) && data.loans.length > 0) {
                data.total_amount_of_loans = data.loans.reduce((sum, loan) => sum + (loan.amount || 0), 0);
                console.log("Calculated total_amount_of_loans from loan list:", data.total_amount_of_loans); 
            } 
            else if (data.loans_per_living_sqm != null && data.living_area_sqm != null && data.living_area_sqm > 0) {
                data.total_amount_of_loans = Math.round(data.loans_per_living_sqm * data.living_area_sqm);
                 console.log("Calculated total_amount_of_loans from loans_per_living_sqm:", data.total_amount_of_loans);
            } 
            else {
                data.total_amount_of_loans = 0;
                console.log("Set total_amount_of_loans to 0 as fallback.");
            }
        }
        data.core_history = core_history;

        selectedItem.set(data);
        return data;

    } catch (error) {
        console.error('Error fetching items:', error);
    } 
}

function populateDataWithS(data){

    data.stadgar_file_name = "";
    data.apartments = "";
    data.built_year = "";
    data.redovisning_file_name = "";
    data.true_association = "";

    if (data.data !== null && data.data.length > 0){
        data.data.forEach(s => {
            for (const key in s) {
                console.log(key)
                console.log(data[key])
                console.log(s[key])
                if ((data[key] === "" || data[key] === null) && s[key] !== ""){
                    data[key] = s[key];
                }
            }
        });

        data.data.forEach(s => {
            if (s.redovisning_file_name === data.file_name) {
                for (const key in s) {
                if (s[key] ==! ""){
                    data[key] = s[key];
                }
            }
            }
        });
    }
    return data;
}

// Helper function to generate star rating HTML using divs and classes
export function generateStars(ratingValue) {
  if (typeof ratingValue !== 'number' || ratingValue < 0 || ratingValue > 100) {
    return ''; // Return empty string if rating is invalid/missing
  }

  const maxStars = 5;
  // Calculate score out of 10 (since Rating.svelte uses Math.round((rating / 100) * 10))
  const scoreOutOfTen = Math.round((ratingValue / 100) * 10); 

  let starsHtml = '<div class="stars">'; // Add a container for flex layout

  for (let i = 0; i < maxStars; i++) {
    if (i < Math.floor(scoreOutOfTen / 2)) {
      // Full star
      starsHtml += '<div class="star filled"></div>';
    } else if (i === Math.floor(scoreOutOfTen / 2) && scoreOutOfTen % 2 !== 0) {
      // Half star
      starsHtml += '<div class="star half-filled"></div>';
    } else {
      // Empty star
      starsHtml += '<div class="star"></div>';
    }
  }

  starsHtml += '</div>'; // Close the container
  return starsHtml;
}

export function tooltip(node) {
  let isTooltipVisible = false;
  const tooltipElement = node.querySelector('.tooltip-content');
  
  function positionTooltip() {
    if (!tooltipElement) return;
    
    // Reset classes
    tooltipElement.classList.remove('right-side', 'center-mobile');
    
    // Get positions and dimensions
    const containerRect = node.getBoundingClientRect();
    const tooltipWidth = tooltipElement.offsetWidth;
    const viewportWidth = window.innerWidth;
    
    // Check if tooltip would go off the right edge
    if (containerRect.right + tooltipWidth + 10 > viewportWidth) {
      // Not enough space on the right, try the left
      if (containerRect.left - tooltipWidth - 10 > 0) {
        // Enough space on the left
        tooltipElement.classList.add('right-side');
      } else if (viewportWidth < 480) {
        // Very small screen, center it
        tooltipElement.classList.add('center-mobile');
      }
    }
  }

  function showTooltip() {
    isTooltipVisible = true;
    // Add visible class to show tooltip
    tooltipElement?.classList.add('visible');
    // Position the tooltip
    setTimeout(positionTooltip, 0);
  }
  
  function hideTooltip() {
    isTooltipVisible = false;
    // Remove visible class to hide tooltip
    tooltipElement?.classList.remove('visible');
  }
  
  function handleMouseEnter() {
    showTooltip();
  }
  
  function handleMouseLeave() {
    hideTooltip();
  }
  
  function handleClick(event) {
    // Toggle tooltip on click (for touch devices)
    event.stopPropagation(); // Prevent document click from immediately closing it
    
    if (isTooltipVisible) {
      hideTooltip();
    } else {
      showTooltip();
    }
  }
  
  function handleDocumentClick(event) {
    // Hide tooltip when clicking outside
    if (isTooltipVisible && !node.contains(event.target)) {
      hideTooltip();
    }
  }
  
  function handleResize() {
    if (isTooltipVisible) {
      positionTooltip();
    }
  }
  
  // Add event listeners
  node.addEventListener('mouseenter', handleMouseEnter);
  node.addEventListener('mouseleave', handleMouseLeave);
  node.addEventListener('click', handleClick);
  document.addEventListener('click', handleDocumentClick);
  window.addEventListener('resize', handleResize);
  
  return {
    destroy() {
      // Clean up
      node.removeEventListener('mouseenter', handleMouseEnter);
      node.removeEventListener('mouseleave', handleMouseLeave);
      node.removeEventListener('click', handleClick);
      document.removeEventListener('click', handleDocumentClick);
      window.removeEventListener('resize', handleResize);
    }
  };
}